module.exports = __webpack_public_path__ + "static/media/search.a860ee9b.svg";